<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间订单.订单编号')">
                <a-input v-model="queryParam.orderNo" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间订单.空间名称')">
                <a-input v-model="queryParam.spaceName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间订单.支付状态')">
                <a-select v-model="queryParam.payStatus" allowClear style="width: 100%">
                  <a-select-option v-for="item in payStatusOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间订单.用户信息')">
                <a-input v-model="queryParam.userInfo" @pressEnter="handleQuery" allow-clear :placeholder="$t('空间订单.用户信息搜索提示')"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间订单.创建时间')">
                <a-range-picker v-model="queryParam.createTimeRange" style="width: 100%" @change="onCreateTimeChange" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="default" :loading="exportLoading" @click="handleExport" v-hasPermi="['space:order:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="userInfo" slot-scope="text, record">
          {{ $t('空间订单.昵称') }}：{{ record.nickName || '-' }} <br/>
          {{ $t('空间订单.手机号') }}：{{ record.mobile || '-' }} <br/>
        </template>
        <span slot="orderAmount" slot-scope="text, record">
          ¥{{ record.orderAmount }}
        </span>
        <span slot="payAmount" slot-scope="text, record">
          <span style="color:#f5222d;font-weight:500;">¥{{ record.payAmount }}</span>
        </span>
        <span slot="payStatus" slot-scope="text, record">
          <a-tag :color="getPayStatusColor(record.payStatus)">
            {{ record.payStatusName }}
          </a-tag>
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ record.payTime ? parseTime(record.payTime) : '-' }}
        </span>
        <span slot="cancelTime" slot-scope="text, record">
          {{ record.cancelTime ? parseTime(record.cancelTime) : '-' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSpaceOrder, exportSpaceOrder } from '@/api/space/order'
import { tableMixin } from '@/store/table-mixin'
import { saveAs } from 'file-saver'

export default {
  name: 'SpaceOrder',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      exportLoading: false,
      total: 0,
      queryParam: {
        orderNo: undefined,
        spaceName: undefined,
        payStatus: undefined,
        userInfo: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      // 支付状态：0-待支付 1-已支付 2-已取消
      payStatusOptions: [
        { value: 0, label: this.$t('空间订单.待支付') },
        { value: 1, label: this.$t('空间订单.已支付') },
        { value: 2, label: this.$t('空间订单.已取消') }
      ],
      columns: [
        { title: this.$t('空间订单.订单编号'), dataIndex: 'orderNo', ellipsis: true, width: 180 },
        { title: this.$t('空间订单.用户信息'), dataIndex: 'userInfo', scopedSlots: { customRender: 'userInfo' }, width: 180 },
        { title: this.$t('空间订单.空间名称'), dataIndex: 'spaceName', ellipsis: true, width: 140 },
        { title: this.$t('空间订单.订单金额'), dataIndex: 'orderAmount', scopedSlots: { customRender: 'orderAmount' }, width: 110 },
        { title: this.$t('空间订单.实付金额'), dataIndex: 'payAmount', scopedSlots: { customRender: 'payAmount' }, width: 110 },
        { title: this.$t('空间订单.支付状态'), dataIndex: 'payStatus', scopedSlots: { customRender: 'payStatus' }, width: 100 },
        { title: this.$t('空间订单.支付时间'), dataIndex: 'payTime', scopedSlots: { customRender: 'payTime' }, width: 160 },
        { title: this.$t('空间订单.取消时间'), dataIndex: 'cancelTime', scopedSlots: { customRender: 'cancelTime' }, width: 160 },
        { title: this.$t('空间订单.取消原因'), dataIndex: 'cancelReason', ellipsis: true, width: 140 },
        { title: this.$t('空间订单.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 160 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const param = this.buildParam()
      pageSpaceOrder(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // userInfo 搜索框同时搜索昵称和手机号（OR关系），后端接收字段为 nickName
    buildParam() {
      const param = { ...this.queryParam }
      delete param.createTimeRange
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      return param
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        orderNo: undefined,
        spaceName: undefined,
        payStatus: undefined,
        userInfo: undefined,
        startTime: undefined,
        endTime: undefined,
        createTimeRange: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onCreateTimeChange(dates, dateStrings) {
      this.queryParam.startTime = dateStrings[0] || undefined
      this.queryParam.endTime = dateStrings[1] || undefined
    },
    getPayStatusColor(status) {
      const colorMap = { 0: 'orange', 1: 'green', 2: 'default' }
      return colorMap[status] || 'default'
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleExport() {
      this.exportLoading = true
      const param = this.buildParam()
      delete param.pageNum
      delete param.pageSize
      exportSpaceOrder(param).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const filename = this.$t('空间订单.空间订单') + '_' + this.parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + '.xls'
        saveAs(blob, filename)
        this.$message.success(this.$t('通用.文本.导出成功'))
      }).finally(() => {
        this.exportLoading = false
      })
    }
  }
}
</script>
